import { render, staticRenderFns } from "./priceformat.vue?vue&type=template&id=02f697a6&"
import script from "./priceformat.vue?vue&type=script&lang=js&"
export * from "./priceformat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02f697a6')) {
      api.createRecord('02f697a6', component.options)
    } else {
      api.reload('02f697a6', component.options)
    }
    module.hot.accept("./priceformat.vue?vue&type=template&id=02f697a6&", function () {
      api.rerender('02f697a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4eyPy7PGaxptW/JS/priceformat.vue"
export default component.exports